import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
// import TextEditer from "../material/textEditor/TextEditor";
import TinyMCE from "../../../material/tinymce/TinyMCE";
// import Draft from "../material/texteditorDraft/Draft";
import Datepicker from "../../../material/datepicker/Datepicker";
import ToggleCheckbox from "../../../material/toggleCheckbox/ToggleCheckbox";
import { RedirectCode400 } from "../../../RedirectCode400";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";

function AddFAQ() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [titlepage, setTitlePage] = useState("");
  const [titleValue, setTitleValue] = useState("");
  const [title, setTitle] = useState(location.state?.title ?? "");
  const [detail, setDetail] = useState(location.state?.detail ?? "");
  const [weight, setWeight] = useState(location.state?.weight ?? "");

  const [defaultOption, setDefaultOption] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (location.state?.type === "faq") {
      setTitlePage("เพิ่มคำถามที่พบบ่อย");
      setTitleValue(location.state?.type);
      setDetail(location.state?.detail);
      setDefaultOption("1");
    } else {
      navigate("/");
    }
  }, []);

  const addFAQ = async () => {
    setLoading(true);
    let res = await adminApi.addFAQ(titleValue, title, detail, weight);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/faq");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateFAQ = async () => {
    setLoading(true);
    let res = await adminApi.updateFAQ(location.state?.id, title, detail);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/management/faq");
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickAddSubmit = (type) => {
    if (!title) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อคำถาม" });
    } else if (!weight) {
      setIsMessage({ type: "warning", data: "กรุณากรอกลำดับ" });
    } else if (isNaN(weight) || weight <= 0) {
      setIsMessage({
        type: "warning",
        data: "กรุณากรอกลำดับเป็นตัวเลขที่ถูกต้อง",
      });
    } else if (!detail) {
      setIsMessage({ type: "warning", data: "กรุณากรอกคำตอบ" });
    } else {
      if (type === "faq") {
        location.state?.detail ? updateFAQ() : addFAQ();
      }
    }
  };

  return (
    <div className="min-w-[376px] overflow-x-auto">
      <PageHeaderV2 titlename={titlepage ?? ""} />
      <div className="flex flex-row justify-center items-start w-full gap-[20px]">
        <div className="w-full">
          <div className="flex flex-col text-[16px] font-['Prompt']">
            ลำดับ
            <input
              type="text"
              className="border border-solid border-[#E0DFE2] rounded-[5px] md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
              placeholder=""
              onChange={(e) => setWeight(e.target.value)}
              value={weight}
            />
          </div>
          <div className="flex flex-col text-[16px] font-['Prompt']">
            หัวข้อ
            <input
              type="text"
              className="border border-solid border-[#E0DFE2] rounded-[5px] md:text-[14px] text-[#000000] p-2 focus:outline-none md:mt-0 md:mb-0 mt-1 mb-4 w-full h-[38px]"
              placeholder=""
              onChange={(e) => setTitle(e.target.value)}
              value={title}
            />
          </div>
          <div>
            <div className="md:text-[14px] text-[16px] text-[#000000] md:my-1 my-3 font-['Prompt']">
              รายละเอียด
            </div>

            <TinyMCE readOnly={false} value={detail} setValue={setDetail} />
          </div>
          <div className="flex flex-row gap-3 justify-end items-center mt-[10px] md:justify-center">
            <button
              onClick={() => {
                navigate("/admin/management/faq");
                setTitle("");
                setDetail("");
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#C0C0C0] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              ยกเลิก
            </button>
            <button
              onClick={() => {
                onClickAddSubmit(location.state?.type);
              }}
              className="button-theme-pg flex justify-center items-center w-[90px] h-[40px] bg-[#2EA669] rounded-[5px] gap-1 text-[#FFFFFF] "
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddFAQ;
